import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a30fac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "working-overlay" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))




export default /*#__PURE__*/_defineComponent({
  __name: 'ModalWorkingOverlay',
  props: {
  showSpinner: Boolean,
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (__props.showSpinner)
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
          key: 0,
          class: "spinner"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})